<template>
  <div class="confirm-order">
    <header-t />
    <nav2 />
    <div class="cont">
      <el-card shadow="nerve" class="card">
        <div v-if="payRadio == 2" class="theSteps">
          <el-steps :active="active" finish-status="success">
            <el-step title="订单确认"></el-step>
            <el-step title="订单提交"></el-step>
            <el-step title="线下打款"></el-step>
          </el-steps>
        </div>
        <div v-else class="theSteps">
          <el-steps :active="active" finish-status="success">
            <el-step title="订单确认"></el-step>
            <el-step title="订单支付"></el-step>
            <el-step title="订单完成"></el-step>
          </el-steps>
        </div>
        <div class="item">
          <div class="title"><span class="tag"></span>订单信息：</div>
          <el-table :data="tableData" :header-cell-style="{ background: '#f8f8f8' }" :cell-style="needStyle" border
            stripe align="center">
            <el-table-column type="index" label="序号" width="50" />
            <el-table-column prop="coursePic" width="230">
              <template slot-scope="scope">
                <img :src="scope.row.coursePic" class="img" />
              </template>
            </el-table-column>
            <el-table-column prop="courseName" label="课程名称" />
            <el-table-column prop="coursePrice" label="商品价格">
              <template slot-scope="scope">
                ¥ {{ scope.row.coursePrice }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="item">
          <div class="title"><span class="tag"></span>支付方式：</div>
          <div class="pay-cont">
            <el-radio-group v-model="payRadio">
              <el-radio v-for="item in payData" :key="item.payMethod" :label="item.payMethod" class="pay-radio">
                <img :src="item.payImg" :class="item.payMethod == payRadio ? 'border' : ''" />
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-if="payRadio == 2" class="item">
          <div class="title"><span class="tag"></span>购买份数：</div>
          <div class="pay-cont">
            <div class="buy_wrap">
              <div class="buy_tit">数量：</div>
              <div class="buy_cont">
                <el-button @click="handleDec" class="bnt_num" type="primary" :disabled="decrease">-</el-button>
                <el-input v-model="buy_num" :min="1" class="buy_input" :style="inputStyle" @input="validateInput"
                  :precision="2" :step="1"></el-input>
                <el-button @click="handleAdd" class="bnt_num" type="primary" :disabled="add">+</el-button>
              </div>
              <!-- <div class="view-total">
                
              </div> -->
            </div>
          </div>
        </div>
        <!-- <div v-if="payRadio == 2" class="item">
          <div class="title"><span class="tag"></span>收款信息：(请按如下账户打款)</div>
          <el-table
            :data="tableData2"
            class="tableData"
            border
            :header-cell-style="{ background: '#f8f8f8' }"
          >
            <el-table-column prop="accountName" label="账户名" />
            <el-table-column prop="cardNo" label="帐号" />
            <el-table-column prop="bankName" label="开户行" />
          </el-table>
        </div>
        <div v-if="payRadio == 2" class="item">
          <div class="title"><span class="tag"></span>付款信息：</div>
          <div class="pay-cont">
            <el-form
              ref="payForm"
              :model="payForm"
              :rules="payFormRules"
              class="payForm"
              label-width="130px"
            >
              <el-form-item prop="name" label="付款账户名称：">
                <el-input
                  v-model="payForm.name"
                  clearable
                  placeholder="请输入付款账户名称"
                  class="phone"
                  tabindex="1"
                />
              </el-form-item>
              <el-form-item prop="time" label="转账时间：">
                <el-date-picker
                  v-model="payForm.time"
                  type="datetime"
                  placeholder="请选择转账时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                />
              </el-form-item>
              <el-form-item prop="imgUrl" label="转账截图：">
                <div>
                  <Image-upload
                    :file-arr="payForm.img_url"
                    @getUploadList="getLogoList"
                  />
                  <p class="img-tip">
                    支持JPG\JPEG\PNG格式，不超过5M！
                  </p>
                </div>
              </el-form-item>
              <el-form-item prop="amount" label="订单金额：">
                <el-input
                  v-model="payForm.amount"
                  type="number"
                  clearable
                  placeholder="请输入订单金额"
                  class="phone"
                  tabindex="2"
                /><span class="inpunt-text"> 元</span>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input
                  v-model="payForm.remark"
                  clearable
                  placeholder="请输入备注"
                  class="phone"
                  type="textarea"
                  :rows="3"
                  tabindex="3"
                />
              </el-form-item>
              <div class="btn-wrap">
                <el-button
                  @click="handleOfflinePay"
                  :disabled="isBuging"
                  type="primary"
                  >提交订单</el-button
                >
              </div>
            </el-form>
          </div>
        </div> -->
        <div class="Agreement">
          <el-checkbox v-model="agreementChecked" @change="handleAgreementChange">我已阅读并同意</el-checkbox>
          <span class="agreement-text" @click="showAgreementDialog">《网络线上学习课程购买及服务协议》</span>
        </div>
        <div v-if="payRadio == 1" class="btn-wrap">
          <!-- <img src="https://www.wlmqcol.com/assets/img/order/wechat.png?version=8.8.0"   @click="handlePayMethod(index)" :class="{img}"> -->
          <el-button @click="handleOrder" :disabled="isBuging || !agreementChecked" type="primary">提交订单</el-button>
        </div>
        <div v-if="payRadio == 2" class="btn-wrap" style="text-align:center">
          <el-button @click="handleOfflinePay2" :disabled="isBuging || !agreementChecked" type="primary">提交订单</el-button>
        </div>
      </el-card>
    </div>
    <Footer />
  </div>
</template>

<script>
import HeaderT from "@/components/HeaderT";
import Nav2 from "@/components/Nav2";
import Footer from "@/components/Footer";
import { getClassDetail } from "@/api/product.js";
import { submitOrder, getPayMethod, getTxToken } from "@/api/order";
import { mapGetters } from 'vuex'
// import ImageUpload from '@/components/Upload/ImageUpload' // 4-16
// import ImgUpload from "@/components/ImageUpload";
// import uploadDefault from '../../assets/upload_default.png'
export default {
  name: "ConfirmOrder",
  components: {
    HeaderT,
    Nav2,
    Footer,
    // ImageUpload
    // ImgUpload,
  },
  computed: {
    ...mapGetters(['phone'])
  },
  data() {
    return {
      buy_num: 1, // 购买份数
      decrease: false, // 
      add: false, //
      payImage: null, //提交转账截图
      pickerOptions: {},
      payForm: {
        // imgUrl: uploadDefault,
        img_url: [],
      },
      tableData2: [],
      active: 1, // 步骤图激活状态
      isBuging: true,
      index: 0,
      inputStyle: `
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      `,
      tableData: [
        /* {
          id: "1",
          courseName: "AA",
          coursePic: "aa",
          coursePrice: 300, // 课程价格
        },
        {
          id: "2",
          courseName: "BB",
          coursePic: "bb",
          coursePrice: 200, // 课程价格
        }, */
      ],
      payData: [
        //  {
        //   payMethod: 1,
        //   payName: '微信支付',
        //   payImg: 'https://www.wlmqcol.com/assets/img/order/wechat@2x.png?version=8.8.0'
        // },
        // {
        //   payMethod: 2,
        //   payName: '线下支付',
        //   payImg: 'https://www.wlmqcol.com/assets/img/order/wechat@2x.png?version=8.8.0'
        // }
      ], //支付方式数据
      payRadio: null,
      totalPrice: 0, // 订单支付金额
      txToken: "", // TxToken
      payFormRules: {
        name: [{ required: true, message: '付款账户名称不能为空', trigger: 'blur' }],
        time: [{ required: true, message: '付款账户名称不能为空', trigger: 'change' }],
        amount: [{ required: true, message: '订单金额不能为空', trigger: 'blur' }]
      },
      agreementChecked: false, // 用户协议勾选状态
      agreementDialogVisible: false, // 用户协议弹窗显示状态
    };
  },
  watch: {
    payRadio: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
        if (newVal !== null) {
          this.isBuging = false;
        } else {
          this.isBuging = true;
        }
      },
    },
    buy_num: {
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal);
        if (oldVal <= 1) {
          this.decrease = true
        }
        if (newVal <= 1) {
          this.decrease = true
        } else {
          this.decrease = false
        }

      },
      immediate: true
    }
  },
  mounted() {
    this.getPayMethod();
    this.getClassDetail(this.$route.query.id);
  },
  methods: {
     // 处理用户协议勾选变化
     handleAgreementChange(val) {
      this.agreementChecked = val;
    },
    // 显示用户协议弹窗
    showAgreementDialog() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      
      this.$alert(`
        <div style="font-size: 14px; line-height: 1.8; color: #333; padding: 10px;">
          <h2 style="text-align: center; font-weight: bold; font-size: 18px; margin-bottom: 20px;">培训服务协议</h2>
          
          <div style="margin-bottom: 20px;">
            <div>甲方（联系方式）：<span style="border-bottom: 1px solid #333; padding: 0 10px;">${this.phone || '________________________'}</span></div>
            <div>乙方（服务提供方）：乌鲁木齐建设职业培训中心</div>
            <div>统一社会信用代码： 52650102778954403X</div>
          </div>

          <div style="text-indent: 2em; margin-bottom: 15px;">
            依据《中华人民共和国职业教育法》《中华人民共和国消费者权益保护法》等法律法规，甲乙双方本着平等、自愿、公平、诚实信用的原则，就甲方购买乙方职业培训证书服务事宜，订立本协议，双方共同遵守。
          </div>

          <div style="font-weight: bold; margin-bottom: 10px;">第一条 服务内容</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">乙方通过官方平台（乌鲁木齐建设网络学院，含网址www.wlmqcol.com及小程序），按行业主管部门教学大纲，为甲方提供线上和线下证书培训服务，含线上课时、线下集中面授、技能实训等内容。</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">乙方将积极配合甲方完成培训及考核，助力甲方顺利取得对应证书。</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">课程有效期自甲方成功购买并激活课程之日起，当年度内有效；有效期届满，线上课程访问权限自动关闭，乙方无需继续提供课程访问服务。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第二条 费用及支付</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">证书服务费用以乙方平台公示的课程价格为准，该费用于甲方获取对应证书，完成教学大纲要求的全部培训服务相关费用。</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">甲方需通过微信支付一次性付清全部费用。</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">乙方收到全款后，为甲方开通课程访问权限，按教学大纲开展培训服务，并为甲方开具相应发票。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第三条 账号与使用规则</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">甲方在乙方平台的注册账号，是接受证书服务的唯一身份标识；甲方需妥善保管账号及密码，对账号下所有操作行为承担法律责任。</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">课程服务仅限甲方个人学习使用，甲方不得将账号转借、共享给第三方，不得对课程内容进行复制、下载、翻录、截图、传播，亦不得将课程用于任何商业用途。</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">若乙方发现甲方账号存在多人异地登录、大量下载等异常使用情形，有权暂停或终止服务，且不予退还任何费用。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第四条 乙方的权利与义务</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">乙方按所购证书教学大纲要求，及时与甲方沟通对接，完成线上课程、线下面授、实训、考核等协议约定的培训服务。</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">乙方安排教学管理人员对培训全过程进行管理服务，组建优秀师资团队开展教学，提供宽敞舒适的面授教室；对需实训的证书，配备安全完善的实训场地，保障甲方顺利完成培训、取得证书。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第五条 甲方的权利与义务</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">协议有效期内，甲方有权通过个人账号登录平台，反复学习已购课程内容。</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">因特殊原因需调整上课时间的，甲方可与乙方沟通，在购课年度内协商调整。</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">甲方需尊重乙方及讲师的知识产权，不得实施任何侵权行为。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第六条 退款政策</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">符合以下全部条件，甲方可申请退款：①因主管部门调整教学大纲导致无法开班，或因意外伤亡等不可抗力未参加培训或考试，乙方审核后全额退费；②因个人原因申请退费的，按对应标准办理（见下表）。</div>
          
          <table border="1" cellspacing="0" cellpadding="5" style="width: 100%; border-collapse: collapse; margin: 10px 0; text-align: center;">
            <tr style="background-color: #f5f7fa;">
              <th style="width: 50px;">序号</th>
              <th style="width: 80px;">培训类型</th>
              <th style="width: 120px;">培训进度</th>
              <th>退费比例</th>
            </tr>
            <tr>
              <td rowspan="4">1</td>
              <td rowspan="4">新取证</td>
              <td style="text-align: left;">网络课程学习进度未超过10%,未参加集中面授和考试。</td>
              <td>退培训费用的100%。</td>
            </tr>
            <tr>
              <td style="text-align: left;">网络课程学习进度超过10%,未参加集中面授和考试。</td>
              <td>退培训费用的75%。</td>
            </tr>
            <tr>
              <td style="text-align: left;">网络课程学习进度超过10%,已参加集中面授，未参加考试。</td>
              <td>退培训费用的50%。</td>
            </tr>
            <tr>
              <td style="text-align: left;">网络课程学习进度超过10%,已参加集中面授和考试。</td>
              <td>不予退费。</td>
            </tr>
            <tr>
              <td rowspan="3">2</td>
              <td rowspan="3">继续教育</td>
              <td style="text-align: left;">网络课程学习进度未超过10%,未参加集中面授。</td>
              <td>退培训费用的100%。</td>
            </tr>
            <tr>
              <td style="text-align: left;">网络课程学习进度超过10%,未参加集中面授。</td>
              <td style="text-align: left;">网络和面授各占总培训费用的50%,其中50%的网络培训费用按学习进度比例退费，50%的面授费用可全退。</td>
            </tr>
            <tr>
              <td style="text-align: left;">网络课程学习进度超过10%,已参加集中面授。</td>
              <td>不予退费。</td>
            </tr>
          </table>

          <div style="text-indent: 2em; margin-bottom: 15px;">符合退款条件的，乙方在收到甲方平台提交的申请及相关材料，核实无误后 15个工作日内，将费用原路退回；退款后，甲方课程访问权限立即终止。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第七条 免责条款</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">因地震、火灾、战争、大规模网络攻击、政府行为等不可抗力，或意外事件、现行技术限制导致服务中断、数据丢失的，双方互不承担违约责任。</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">因甲方自身网络故障或操作失误，导致无法正常使用服务，乙方不承担责任。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第八条 违约责任</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">任何一方违反本协议约定，需承担相应违约责任，若甲方违反本协议第三条约定，乙方有权单方立即终止协议、停止服务，已收费用不予退还；同时，乙方保留追究甲方知识产权侵权及其他法律责任的权利。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第九条 保密条款</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">甲乙双方对履行本协议过程中知悉的对方未公开信息（含技术信息、经营信息、个人信息等），均负有保密义务，不得向任何第三方泄露。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第十条 协议终止</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">本协议在年度有效期届满、证书服务全部履行完毕或双方协商一致时终止。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第十一条 法律适用与争议解决</div>
          <div style="text-indent: 2em; margin-bottom: 15px;">本协议的订立、效力及争议解决，均适用中华人民共和国法律。因本协议引发的争议，双方应友好协商解决；协商不成的，任何一方有权向乙方所在地有管辖权的人民法院提起诉讼。乙方投诉电话：0991-4606198、18299159999。</div>

          <div style="font-weight: bold; margin-bottom: 10px;">第十二条 其他</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">乙方平台公示的课程介绍、服务规则、用户协议等，均为本协议有效组成部分，与本协议具有同等法律效力。本协议自甲方在线勾选 “我已阅读并同意《网络线上学习课程购买及服务协议》” 且成功付款之日起生效。</div>
          <div style="text-indent: 2em; margin-bottom: 10px;">本协议一式两份，甲乙双方各执一份，具有同等法律效力；本协议以数据电文形式订立，双方均认可其法律效力。</div>
          
          <div style="margin-top: 30px;">
            <div style="margin-bottom: 10px; font-weight: bold;">甲方（学员）确认：本人已完全阅读、理解并同意接受上述协议的全部条款。</div>
            <div style="margin-bottom: 10px;">确认方式：在线勾选确认</div>
            <div style="margin-bottom: 30px;">确认日期：${year}年${month}月${day}日</div>
            
            <div style="margin-bottom: 10px;">乙方（服务提供方）：乌鲁木齐建设职业培训中心</div>
            <div>日期：${year}年${month}月${day}日</div>
          </div>
        </div>
      `, '培训服务协议', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '我已阅读并同意',
        customClass: 'agreement-dialog',
        callback: action => {
          if (action === 'confirm') {
            this.agreementChecked = true;
          }
        }
      });
    },
    validateInput() {
      const intValue = parseInt(this.buy_num);
      if (isNaN(intValue) || intValue < 1) {
        this.buy_num = 1;
      } else {
        this.buy_num = intValue;
      }
    },
    // 获取支付方式
    getPayMethod() {
      getPayMethod().then((res) => {
        if (res.status === 200) {
          if (res.data.code === 0) {
            this.payData = res.data.data.payMethods;
            this.payRadio = this.payData[0].payMethod;
            this.tableData2.push({
              accountName: res.data.data.offlineBank.accountName,
              bankName: res.data.data.offlineBank.bankName,
              cardNo: res.data.data.offlineBank.cardNo,
            });
          }
        }
      });
    },
    // 那课程详细信息
    getClassDetail(ClassId) {
      getClassDetail(ClassId).then((res) => {
        if (res.data.code === 0) {
          let obj = {
            courseName: res.data.data.courseName,
            coursePic: res.data.data.coursePic,
            coursePrice: res.data.data.coursePrice,
          };
          this.tableData.push(obj);
          this.totalPrice = res.data.data.coursePrice;
        }
      });
    },
    //总价计算
    getTotal(param) {
      const { columns, data } = param;
      // console.log(columns);
      // console.log(data);
      const sums = [];
      // const arr = ["test1","test2","test3","test4"];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总价";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        // if(arr.indexOf(column.property)!==-1){

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += " 元";
          sums[index];
        } else {
          // sums[index] = 'N/A';
          // }
        }
      });
      console.log(sums);
      sums[3] = `¥ ${sums[3]}`;
      return sums;
    },
    needStyle(column) {
      let cellStyle;
      switch (column.column.property) {
        case "test1":
          cellStyle = "color:red";
          break;
        case "test2":
          cellStyle = "color:red";
          break;
        case "test3":
          cellStyle = "color:blue";
          break;
        default:
          cellStyle = "";
      }
      return cellStyle;
    },
    // 处理提交订单的数据
    handlerData() { // 0 线上付款，1 线下付款
      let tmpObj = this.payData[this.payRadio];
      console.log(tmpObj);
      let arr = [];
      console.log(arr.push(tmpObj));
      let obj2 = null
      const obj = {
        productName: this.tableData[0].courseName, //产品名（填写课程名）
        productId: Number(this.$route.query.id), //产品Id（填写课程Id）
        productType: 1, //产品类型 1 课程（目前先写死）
        quantity: this.buy_num, // 
        payDetail: {
          payMethod: this.payRadio, //支付方式 1 微信支付
          payPrice: this.totalPrice * this.buy_num, //支付金额
          productPrice: this.totalPrice, //产品单价
          // subjectId: 'a' //可选	如使用优惠券等，填写优惠券ID
          /* offlineAccountName: this.payRadio === 2 ? this.payForm.name : '',
          offlinePayTime: this.payRadio === 2 ? this.payForm.time : '',
          offlineImg: this.payRadio === 2 ? this.payImage[0] : '', */
        },
        txToken: this.txToken,
        amount: this.payForm.amount,
        remark: this.payForm.remark
      };
      obj2 = this.payRadio == 2 ? Object.assign(obj, { quantity: this.buy_num }) : obj
      this.isBuging = true;
      submitOrder(obj2).then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          console.log("en");
          const tmpUrl = this.payRadio === 1 ? `/confirm/payment?orderId=${res.data.data.orderId}&courseId=${this.$route.query.id}` : '/entCenter/orderlistManagement'
          if (this.payRadio === 2) {
            this.$message({
              type: 'success',
              message: '订单提交成功！',
              duration: 500,
              onClose: () => {
                this.$router.push({
                  path: tmpUrl,
                });
              }
            })
          } else {
            this.$router.push({
              path: tmpUrl,
            });
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    //提交订单
    async handleOrder() {
      await this.getTxToken();
      this.handlerData()


    },
    // 获取getTxToken
    getTxToken() {
      return new Promise((resolve) => {
        const obj = {
          tokenType: 1, //1 订单提交token
        };
        getTxToken(obj).then((res) => {
          if (res.data.code === 0) {
            console.log(res);
            this.txToken = res.data.data.txToken;
            resolve();
          }
        });
      });
    },
    // 选择支付方式
    handlePayMethod() { },
    //线下支付
    async handleOfflinePay() {
      console.log("线下支付提交....");
      console.log(this.payImage);
      if (this.payImage === null || this.payImage === undefined) {
        this.$message({
          type: 'error',
          message: '请上传转账凭证截图'
        })
        return
      } else {
        await this.getTxToken()
        this.$refs.payForm.validate((vaild) => {
          if (vaild) {
            this.handlerData()
          } else {
            console.log('nopass');
          }
        })
      }

    },
    // 新
    handleOfflinePay2() {
      // await this.getTxToken()
      this.handleOrder()
    },




    //
    /* fileList(val) {
      console.log('hahaha:', val);
      this.payImage = val
    }, */
    // 获取收集点门面照片
    getLogoList(val) {
      this.payForm.img_url = val
      this.payImage = this.payForm.img_url
    },
    //
    handleAdd() {
      this.buy_num = this.buy_num + 1
    },
    handleDec() {
      if (this.buy_num > 1)
        this.buy_num = this.buy_num - 1
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.confirm-order {
  height: 100%;
  background-color: #f5f5f5;

  .cont {
    width: 1170px;
    margin: 20px auto;

    .card {
      .theSteps {
        text-align: left;
      }
    }
  }

  .item {
    margin-top: 20px;

    .title {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      text-align: left;
      margin: 40px 0 20px 0;
      border-bottom: 1px #ebebeb solid;
      padding-bottom: 8px;

      .tag {
        border-left: 3px solid #409EFF;
        margin-right: 10px;
      }
    }

    .img {
      width: 200px;
      height: 150px;
    }

    .PayMethod {
      font-size: 14px;
      font-weight: bold;
      text-align: left;
    }

    .pay-cont {
      text-align: left;
      margin-top: 20px;

      img {
        border: none;
        padding: 3px;
        border: 2px #f5f5f5 solid;
        width: 150px;
        height: 50px;
        margin-top: 0;
      }

      .border {
        border: 1px #43bc60 solid;
      }

      /deep/ .el-radio__input {
        display: none;
      }

      .payForm {
        width: 600px;

        .phone {
          width: 300px;
        }
      }

      .buy_wrap {
        display: flex;
        width: 500px;

        // border:1px #f00 solid;
        .buy_tit {
          line-height: 40px;
          font-size: 14px;
        }

        .buy_cont {

          .buy_input {
            width: 70px;
            /* text-align: center; */
            margin: 0 10px;
          }

          .bnt_num {
            /* width: 40px; */
          }
        }

      }
    }

    img {
      float: left;
      margin-top: 5px;
      border: 1px solid #eee;
      padding: 5px;

    }

  
  }

  .btn-wrap {
    margin-top: 20px;
    text-align: right;
  }
}
.Agreement {
    margin-top: 20px;
    text-align: right;
    
    .agreement-text {
      color: #409EFF;
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .btn-wrap {
    margin-top: 20px;
    text-align: right;
  }
</style>

<style>
/* 全局样式，不使用scoped */
.agreement-dialog {
  width: 900px !important;
  max-width: 95% !important;
}

.agreement-dialog .el-message-box__content {
  max-height: 70vh;
  overflow-y: auto;
  line-height: 1.8;
}

.agreement-dialog .el-message-box__header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.agreement-dialog .el-message-box__title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.agreement-dialog .el-message-box__headerbtn {
  top: 15px;
}

.agreement-dialog .el-message-box__btns {
  padding: 10px 20px 15px;
  text-align: center;
}

.agreement-dialog .el-button--primary {
  width: 160px;
  height: 40px;
  font-size: 16px;
}

/* 增加表格样式 */
.agreement-dialog table {
  border-collapse: collapse;
  width: 100%;
  margin: 15px 0;
}

.agreement-dialog table th,
.agreement-dialog table td {
  border: 1px solid #dcdfe6;
  padding: 12px 8px;
  line-height: 1.6;
}

.agreement-dialog table th {
  background-color: #f5f7fa;
  font-weight: bold;
  text-align: center;
}

.agreement-dialog table td {
  text-align: left;
}

/* 增加段落间距 */
.agreement-dialog div {
  margin-bottom: 10px;
}

.agreement-dialog div[style*="font-weight: bold"] {
  margin-top: 15px;
  margin-bottom: 10px;
}
</style>